<template>
  <div class="table">
    <Table
      stripe
      ref="table"
      :height="height"
      :loading="loading"
      :columns="getColumns"
      :data="list"
      @on-row-dblclick="dbclick"
      @on-selection-change="
        ;(selection = $event), $emit('on-selection-change', $event)
      "
      @on-sort-change="$emit('on-sort-change', $event)"
    >
      <template slot-scope="{ row, index }" slot="operate">
        <slot name="operate" :row="row" :index="index"></slot>
      </template>
    </Table>
    <Page
      v-if="page"
      show-total
      show-sizer
      show-elevator
      class="page"
      placement="top"
      :current="table.pageIndex + 1"
      :total="total"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
let deepGet = function (str, obj) {
  let arr = str.split('.')
  let res = arr.reduce(function (p, c) {
    return p[c]
  }, obj)
  return res
}
export default {
  name: 'TableWithPageBeta',
  props: {
    func: {
      type: Function,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    condition: {
      type: Object,
      default: () => ({}),
    },
    page: {
      type: Boolean,
      default: true,
    },
    initData: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: '',
    },
    isWx: {
      type: Boolean,
      default: false,
    },
    dataKey: {
      type: String,
      default: 'data',
    },
  },
  data() {
    return {
      loading: false,
      table: {
        pageSize: 10,
        pageIndex: 0,
      },
      total: 0,
      list: [],
      selection: [],
    }
  },
  computed: {
    ...mapState('table', ['pageSizeOpts']),
    getColumns() {
      return this.columns.map((v) => {
        if (this.minWidth && !v.width) {
          v.minWidth = 150
        }
        return v
      })
    },
  },
  methods: {
    async init(reset = false) {
      if (reset) {
        this.table.pageIndex = 0
      }
      this.loading = true
      let res = await this.func({
        ...this.table,
        ...this.condition,
      })
      let [list, count] = res

      this.loading = false
      if (list && list.success) {
        let listData = this.dataKey.includes('.')
          ? deepGet(this.dataKey, list)
          : list[this.dataKey]
        this.list = this.isWx ? this.$replaceLog(listData) : listData || []
        this.$emit('list', this.list)
      }
      if (count && count.success) {
        this.total = count.data || 0
        this.$emit('total', this.total)
      }
    },

    initLoad() {
      this.table.pageIndex = 0
      this.init()
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.table.pageSize = pageSize
      this.init()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.table.pageIndex = pageIndex - 1
      this.init()
    },
    dbclick(row, i) {
      this.$emit('dblclick', row, i)
    },
    exportCsvOrigin(e) {
      return this.$refs.table.exportCsv(e)
    },
    exportCsv({ filename, type, columns, format, ...others }) {
      let data = []
      if (type === '1') {
        data = this.list
      }
      if (type === '2') {
        data = this.selection
      }
      if (data.length === 0) return this.$Message.warning('未选中数据')
      if (format) data = data.map(format)
      this.$refs.table.exportCsv({
        filename: filename,
        columns:
          columns ||
          this.columns.filter((el) => {
            return (
              el.type !== 'selection' &&
              el.type !== 'expand' &&
              el.title !== '操作'
            )
          }),
        data,
        ...others,
      })
    },
  },
  created() {
    if (this.initData) this.init()
  },
}
</script>
<style lang="less" scope>
.page {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/TableWithPageBeta.vue